import { Transition } from '@headlessui/react';
import DLoaderBubble from '../DLoaderBubble';
import { DANTE_THEME_CHAT } from '@/constants';

/**
 * DLoaderBubbleLoading - A specialized loading component for Bubble and BubbleDirectLink
 * 
 * This component uses the new DLoaderBubble with element color support instead of the default DLoaderTraining.
 * It's designed to be used specifically in Bubble and BubbleDirectLink contexts where customization
 * data is available.
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.show - Whether to show the loading component
 * @param {Object} props.style - Additional styles to apply
 * @param {string} props.height - Height class for the container
 * @param {string} props.elementColor - Element color for the loader
 * @param {number} props.size - Size of the loader (default: 64px)
 * @returns {JSX.Element} The loading component
 */
const DLoaderBubbleLoading = ({ 
  show = false, 
  style = {}, 
  height = 'h-screen',
  elementColor = DANTE_THEME_CHAT.element_color,
  size = 64
}) => {
  return (
    <Transition show={show}>
      <div 
        className={`transition data-[closed]:opacity-0 duration-300 ${height} w-full flex items-center justify-center`} 
        style={style}
      >
        <DLoaderBubble elementColor={elementColor} size={size} />
      </div>
    </Transition>
  );
};

export default DLoaderBubbleLoading;
